import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { Tooltip } from 'react-bootstrap-5';

export default class TableEditControls extends React.Component {
  static propTypes = {
    allowColumnEditing: PropTypes.bool.isRequired,
    allowRowEditing: PropTypes.bool.isRequired,
    columnCount: PropTypes.number.isRequired,
    rowCount: PropTypes.number.isRequired,
    selectedColumnIndex: PropTypes.number,
    selectedRowIndex: PropTypes.number,
    selectedSection: PropTypes.oneOf(['bodyRows', 'headerRows']),

    onAddColumnAfter: PropTypes.func.isRequired,
    onAddColumnBefore: PropTypes.func.isRequired,
    onAddRowAfter: PropTypes.func.isRequired,
    onAddRowBefore: PropTypes.func.isRequired,
    onDeleteColumn: PropTypes.func.isRequired,
    onDeleteRow: PropTypes.func.isRequired,
    onEditStop: PropTypes.func.isRequired,
    onMoveColumnLeft: PropTypes.func.isRequired,
    onMoveColumnRight: PropTypes.func.isRequired,
    onMoveRowDown: PropTypes.func.isRequired,
    onMoveRowUp: PropTypes.func.isRequired
  }

  state = {
    hoveredIconName: null
  }

  handleIconMouseEnter = (event) => {
    this.setState({ hoveredIconName: event.target.dataset.name });
  }

  handleIconMouseLeave = () => {
    this.setState({ hoveredIconName: null });
  }

  render() {
    const columnControls = this.getColumnControls();
    const rowControls = this.getRowControls();

    return (
      <React.Fragment>
        <div className="edit-controls">
          {this.renderControls(rowControls)}
          {this.renderControls(columnControls)}
        </div>


        <span
          className="click-target table-edit-control"
          name="done"
          onClick={this.props.onEditStop}
        >
          <React.Fragment>
            <FontAwesomeIcon icon={faCheck} />
            Done
          </React.Fragment>
        </span>
      </React.Fragment>
    );
  }

  getColumnControls() {
    if (!this.props.allowColumnEditing) {
      return null;
    }

    if (this.props.selectedColumnIndex == null) {
      return [
        this.renderControl('add-column-after', 'Add Column', this.props.onAddColumnAfter),
        this.renderControl('delete-column', 'Delete Column', this.props.onDeleteColumn)
      ];
    }

    const controls = [
      this.renderControl('add-column-before', 'Add Column Before', this.props.onAddColumnBefore),
      this.renderControl('add-column-after', 'Add Column After', this.props.onAddColumnAfter),
    ];

    if (this.props.selectedColumnIndex > 0) {
      controls.push(
        this.renderControl('move-column-left', 'Move Column Left', this.props.onMoveColumnLeft)
      );
    }

    if (this.props.selectedColumnIndex < this.props.columnCount - 1) {
      controls.push(
        this.renderControl('move-column-right', 'Move Column Right', this.props.onMoveColumnRight)
      );
    }

    controls.push(this.renderControl('delete-column', 'Delete Column', this.props.onDeleteColumn));

    return controls;
  }

  getRowControls() {
    if (!this.props.allowRowEditing || this.props.selectedSection === 'headerRows') {
      return null;
    }

    if (this.props.selectedRowIndex == null) {
      return [
        this.renderControl('add-row-after', 'Add Row', this.props.onAddRowAfter),
        this.renderControl('delete-row', 'Delete Row', this.props.onDeleteRow)
      ];
    }

    const controls = [
      this.renderControl('add-row-after', 'Add Row After', this.props.onAddRowAfter),
      this.renderControl('add-row-before', 'Add Row Before', this.props.onAddRowBefore)
    ];

    if (this.props.selectedRowIndex > 0) {
      controls.push(
        this.renderControl('move-row-up', 'Move Row Up', this.props.onMoveRowUp)
      );
    }

    if (this.props.selectedRowIndex < this.props.rowCount - 1) {
      controls.push(
        this.renderControl('move-row-down', 'Move Row Down', this.props.onMoveRowDown)
      );
    }

    controls.push(this.renderControl('delete-row', 'Delete Row', this.props.onDeleteRow));

    return controls;
  }

  renderControls(controls) {
    if (!controls) {
      return null;
    }

    return (
      <div className="table-edit-icon-group">
        {controls}
      </div>
    );
  }

  renderControl(name, label, onClick) {
    return (
      <div
        className={`table-edit-control table-edit-icon ${name}`}
        data-name={name}
        key={name}
        name={name}
        onClick={onClick}
        onMouseEnter={this.handleIconMouseEnter}
        onMouseLeave={this.handleIconMouseLeave}
      >
        {this.renderTooltip(name, label)}
      </div>
    );
  }

  // Can't use react-bootstrap OverlayTrigger; it puts the tooltip in the outer DOM, not the IFrame
  renderTooltip(name, label) {
    if (this.state.hoveredIconName !== name) {
      return null;
    }

    return (
      <Tooltip id={name}>
        {label}
      </Tooltip>
    );
  }
}
